module.exports = "{{formatDate($parent.row.created_at)}}"